
.formFieldsContainer, .fieldGroupContainer, .fieldContainer, .buttonContainer {
    display: flex;
}

.fieldContainer, .dragAndDrop {
    margin-bottom: 20px;
}

.formFieldsContainer {
    flex-direction: column;
    margin-bottom: 0px;
}

.fieldGroupContainer {
    gap: 10px;
    width: 100%;
}

.fieldContainer {
    flex: 1 1;
}

.fieldContainer > * {
    width: 100%;
}

.buttonContainer {
    flex-direction: row-reverse;
    margin: 0px;
}

.checkboxContainer {
    display: flex;
    align-items: center;
    margin-left: -10px;
}